import React from "react";
import { Card, ListGroup, Spinner } from "react-bootstrap";
import {
  FaFax,
  FaPhoneAlt,
  FaMobile,
  FaEnvelope,
  FaClock,
} from "react-icons/fa";
import Masonry from "react-masonry-css";


import { Divider } from "antd";

import useFetch from "../../hooks/useFetch";
import HeroSection from "../../utilities/HeroSection";

function PaulineMission({ banners, isLoading, error }) {
  const allContacts = useFetch("contacts/");
  const [contacts, setContacts] = React.useState(null);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  React.useEffect(() => {
    setContacts(allContacts);
  }, [allContacts, contacts]);

  return (
    <>
      <HeroSection banners={banners} isLoading={isLoading} error={error} />
      <Card className="text-start p-md-3 border-0">
        <Card.Body
          style={{ maxWidth: "1200px", margin: "0 auto", fontSize: "17px" }}
        >
          <Card.Text className="my-4" style={{ lineHeight: "1.5" }}>
            The Daughters of St. Paul dedicate their lives to the Gospel. While
            it is important to provide material bread for all people and ensure
            that they are able to live in a dignified way, it is equally urgent
            to distribute the bread of the Gospel so as to respond to each
            person's hunger for the Truth and for God. <br /> Fr. Alberione
            invited the Daughters of St. Paul to center their mission on the
            Word of God, but he also said: "Don't speak only about religion.
            Speak about everything in a Christian way." And he told them to do
            this by taking advantage of all the technologies of communication,
            by blazing new trails for the Gospel, by striving to be present at
            the 'crossroads' and 'meeting places' of humanity so that always
            more people can get to know and welcome Jesus. The Daughters of St.
            Paul live for this mission, which they carry out through numerous
            activities.
          </Card.Text>

          <Card.Title
            className="my-4 font-header text-center color-primary"
            style={{ fontSize: "2.1rem", fontWeight: 400, color: "#d9001b" }}
          >
            Pauline Book Centers
          </Card.Title>

          <Masonry
            breakpointCols={{
              default: 3, // Number of columns on larger screens
              768: 1, // Number of columns on mobile devices
              960: 2,
            }}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            {!contacts ? (
              <Spinner animation="border" />
            ) : (
              contacts.map((center, index) => (
                <Card key={index} className="mb-4 card-border"   style={{cursor:"pointer",}}>
                  <Card.Img
                    className="p-3"
                    variant="top"
                    src={center.center_image?.replace("media", "static")}
                  />
                  <Card.Body>
                    <Card.Title style={{ color: "#d9001b" }}>
                      Contact Details
                    </Card.Title>
                    <Card.Text>
                      <address className="text-left">
                        {center.center_name}
                        <br />
                        {center.address}
                        <br />
                        {center.location}
                        <br />
                        <span>
                          <FaPhoneAlt style={{ color: "#d9001b" }} />{" "}
                          <strong style={{ color: "#d9001b" }}>Tel</strong>:{" "}
                        </span>
                        <a href={`tel:${center.tel}`}>{center.tel}</a>
                        <br />
                        <span>
                          <FaFax style={{ color: "#d9001b" }} />{" "}
                          <strong style={{ color: "#d9001b" }}>Fax</strong>:{" "}
                        </span>
                        <a href={`fax:${center.center_fax}`}>
                          {center.center_fax}
                        </a>
                        <br />
                        <span>
                          <FaMobile style={{ color: "#d9001b" }} />{" "}
                          <strong style={{ color: "#d9001b" }}>Mob</strong>:{" "}
                        </span>
                        <a href={`tel:${center.mobile}`}>{center.mobile}</a>
                        <br />
                        <span>
                          <FaEnvelope style={{ color: "#d9001b" }} />{" "}
                          <strong style={{ color: "#d9001b" }}>Email</strong>:{" "}
                        </span>
                        <a href={`mailto:${center.email}`}>{center.email}</a>
                      </address>
                    </Card.Text>

                    <Divider />
                    <div style={{ maxHeight: "30vh", overflowY: "auto" }}>
                      <Card.Title
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "2px",
                        }}
                      >
                        <FaClock /> Opening Hours
                      </Card.Title>
                      <ListGroup variant="flush">
                        {center.opening_hours &&
                        center.opening_hours.length === 0 ? (
                          <ListGroup.Item>No Data</ListGroup.Item>
                        ) : (
                          center.opening_hours.map((opening, index) => {
                            const startDay =
                              opening.start_day.charAt(0).toUpperCase() +
                              opening.start_day.slice(1);
                            const openingTime = new Date(
                              `2000-01-01T${opening.opening_time}`
                            );
                            const closingTime = new Date(
                              `2000-01-01T${opening.closing_time}`
                            );
                            const currentTime = new Date();
                            const currentHour = currentTime.getHours();
                            const currentMinute = currentTime.getMinutes();
                            const openingHour = openingTime.getHours();
                            const openingMinute = openingTime.getMinutes();
                            const closingHour = closingTime.getHours();
                            const closingMinute = closingTime.getMinutes();
                            const isOpen =
                              (currentHour > openingHour ||
                                (currentHour === openingHour &&
                                  currentMinute >= openingMinute)) &&
                              (currentHour < closingHour ||
                                (currentHour === closingHour &&
                                  currentMinute <= closingMinute));
                            const statusText = isOpen ? "Open" : "Closed";
                            const statusVariant = isOpen
                              ? "success"
                              : "warning";

                            return (
                              <ListGroup.Item key={index}>
                                <strong style={{ color: "#d9001b" }}>
                                  {startDay}
                                </strong>
                                :{" "}
                                {openingTime.toLocaleTimeString([], {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}{" "}
                                to{" "}
                                {closingTime.toLocaleTimeString([], {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}{" "}
                                <span
                                  className={`text-${statusVariant}`}
                                  style={{ color: isOpen ? "green" : "red" }}
                                >
                                  {statusText}
                                </span>
                              </ListGroup.Item>
                            );
                          })
                        )}
                      </ListGroup>
                    </div>
                  </Card.Body>
                </Card>
              ))
            )}
          </Masonry>
        </Card.Body>
      </Card>
    </>
  );
}

export default PaulineMission;
